module.exports = __webpack_public_path__ + "img/scan 2.ca84d64f.jpg";